import { memo, type ReactNode } from 'react';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

import { WORKSPACE_AGENT_SESSION_ROW_PREVIEW_MARKDOWN_COMPONENTS } from '~/components/v2/components/workspace/workspace-agent-panel/markdown/workspaceAgentSessionRowPreviewMarkdownComponents';

const WORKSPACE_AGENT_SESSION_ROW_PREVIEW_REMARK_PLUGINS = [remarkGfm];

export type WorkspaceAgentPanelMyTasksRowPreviewContainerProps = {
  children: ReactNode;
};

const WorkspaceAgentPanelMyTasksRowPreviewContainer = memo(
  ({ children }: WorkspaceAgentPanelMyTasksRowPreviewContainerProps) => {
    return (
      <div
        className="h-5 min-w-0 truncate pl-7 ads:text-secondary text-12 text-gray-11 leading-5"
        data-testid="WORKSPACE_AGENT_PANEL_MY_TASKS_ROW_PREVIEW"
      >
        {children}
      </div>
    );
  },
);

WorkspaceAgentPanelMyTasksRowPreviewContainer.displayName = 'WorkspaceAgentPanelMyTasksRowPreviewContainer';

export type WorkspaceAgentPanelMyTasksRowPreviewProps = {
  markdown: string | undefined;
};

export type WorkspaceAgentPanelMyTasksRowPlainPreviewProps = {
  text: string;
};

export const WorkspaceAgentPanelMyTasksRowPlainPreview = memo(
  ({ text }: WorkspaceAgentPanelMyTasksRowPlainPreviewProps) => {
    return <WorkspaceAgentPanelMyTasksRowPreviewContainer>{text}</WorkspaceAgentPanelMyTasksRowPreviewContainer>;
  },
);

WorkspaceAgentPanelMyTasksRowPlainPreview.displayName = 'WorkspaceAgentPanelMyTasksRowPlainPreview';

export const WorkspaceAgentPanelMyTasksRowPreview = memo(({ markdown }: WorkspaceAgentPanelMyTasksRowPreviewProps) => {
  if (!markdown) {
    return null;
  }

  return (
    <WorkspaceAgentPanelMyTasksRowPreviewContainer>
      <Markdown
        components={WORKSPACE_AGENT_SESSION_ROW_PREVIEW_MARKDOWN_COMPONENTS}
        remarkPlugins={WORKSPACE_AGENT_SESSION_ROW_PREVIEW_REMARK_PLUGINS}
      >
        {markdown}
      </Markdown>
    </WorkspaceAgentPanelMyTasksRowPreviewContainer>
  );
});

WorkspaceAgentPanelMyTasksRowPreview.displayName = 'WorkspaceAgentPanelMyTasksRowPreview';
